import React from "react";

export const Logo = ({ className = "", size = "md" }) => {
  const sizes = {
    sm: "text-xl",
    md: "text-2xl",
    lg: "text-4xl",
  };
  return (
    <div
      className={`font-heading ${sizes[size]} font-light tracking-[0.32em] text-[#FFFFF0] flex items-center gap-3 ${className}`}
      data-testid="elecars-logo"
    >
      <span className="relative inline-flex items-center">
        <span className="absolute -left-3 top-1/2 -translate-y-1/2 h-px w-1 bg-[#D4AF37]" />
        ELECARS
      </span>
      <span className="hidden sm:block w-8 h-px bg-gradient-to-r from-[#D4AF37] to-transparent" />
    </div>
  );
};

export default Logo;
